import {
  isSharesProject,
  SimulatorScenario,
  TaxExemptionMechanicsEnum,
  type ProjectSimulatorQuery,
  type SharesProject,
} from "@tudigo-monorepo/core-tudigo-api-models";

import { ProjectsComparatorSimulatorRoiCardProps } from "../components/projects-comparator/projects-comparator-modal/projects-comparator-simulator/projects-comparator-simulator-roi-card";

const SIMULATOR_TAX_RATES_BY_PRIORITY = {
  1: { JEIR: 50 },
  2: { JEIC: 30 },
  3: { IR: 18 },
} as const;

/**
 * @param project SharesProject
 * @returns number
 * @source https://www.notion.so/tudigo/Simulation-informations-de41584c071d4bd282aa9c2ac45a582a?pvs=4#2da6006595504c869ec80481fb9a4c4c
 */
export function getShareProjectTaxRateByPriorityOrder(
  project: SharesProject,
): number {
  if (project.taxExemptionMechanics?.includes(TaxExemptionMechanicsEnum.JEIR)) {
    return SIMULATOR_TAX_RATES_BY_PRIORITY[1].JEIR;
  }

  if (project.taxExemptionMechanics?.includes(TaxExemptionMechanicsEnum.JEIC)) {
    return SIMULATOR_TAX_RATES_BY_PRIORITY[2].JEIC;
  }

  if (project.taxExemptionMechanics?.includes(TaxExemptionMechanicsEnum.IR)) {
    return SIMULATOR_TAX_RATES_BY_PRIORITY[3].IR;
  }

  return 1;
}

export function getProjectComparatorSimatorQuery({
  amountInCents,
  project,
}: ProjectsComparatorSimulatorRoiCardProps): ProjectSimulatorQuery {
  if (isSharesProject(project)) {
    return {
      amountInCents,
      scenario: SimulatorScenario.Medium,
      taxRate: getShareProjectTaxRateByPriorityOrder(project),
    };
  }

  return { amountInCents };
}
